import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImmomioTooltipDirective, TooltipPosition } from '@immomio/ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss'],
  imports: [ImmomioTooltipDirective, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HintComponent {
  readonly placement = input<TooltipPosition>('top');
}
